import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { locaisModuleName, locaisStorage, TiposLocais } from "../shared/data.service";
import { Local, LocalCombustivel } from "../shared/local.model";
import {editRoute, newRoute, configuracaoModuleName} from "../../../shared/services/data.service";
import { LocalNavigationService } from "../shared/local-navigation.service";
import { LocalApiService } from "../shared/local-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { LocalService } from "../shared/local.service";
import { AbastecimentoService } from "../../shared/abastecimento.service";
import {abastecimentosModuleName} from "../../shared/data.service";

@Component({
    template: require('./local-form.component.html'),
    styles: [require('./local-form.component.css')]
})
export class LocalFormComponent implements OnInit {
    locaisModule: any = locaisModuleName;
    formObject: any = new Local();
    tipoLocalObject: any = {};
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    module: any = abastecimentosModuleName;
    configuracaoModule: any = configuracaoModuleName;


    tiposLocaisList: any[] = TiposLocais;
    localCombustiveis: LocalCombustivel[] = [];

    form: FormGroup;
    ativo = new FormControl('');
    nome = new FormControl('', Validators.required);
    descricao = new FormControl('');
    tipo = new FormControl('', Validators.required);

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responseLocal: any;

    constructor(
        private _route: ActivatedRoute,
        private _localNavigationService: LocalNavigationService,
        private _localApiService: LocalApiService,
        private _localService: LocalService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _abastecimentoService: AbastecimentoService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            nome: this.nome,
            descricao: this.descricao,
            tipo: this.tipo
        });
    }

    ngOnInit() {
        this.isNewAutoComplete();
    }

    clickGoToList() {
        this.goToList();
    }

    clickGoToSettings() {
        this._abastecimentoService.goToSetting();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            let object:Local = this._utilService.cloneObject(this.formObject);

            if (this.tipoLocalObject.Key) {
                object.tipo = this.tipoLocalObject.Key;
            }

            if (this.formObject.id) {
                this.onEditLocal(object);
            } else {
                this.onAddLocal(object);
            }
        }
    }

    private onAddLocal(object: Local) {
        this._localApiService.onPost(object, this.onDone);
    }

    private onEditLocal(object: Local) {
        this._localApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responseLocal = Response;
            let localId: number;

            if (this.formObject.id) {
                localId = this.formObject.id;
                this._utilService.swalMessageEditSuccess();
            } else {
                localId = Response.id;
                this._utilService.swalMessageAddSuccess();
            }

            this.submitLocalCombustivel(localId);
            this.toLeaveHere();

        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum local encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._localApiService.onGetById(id, onDone);
    }

    private getLocalCombustiveis(localId: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.localCombustiveis = Response;
            }
        }.bind(this));

        this._localApiService.onGetLocalCombustivelByLocal(localId, onDone);
    }

    private testSession() {
        var id: number;
        var session: any = this._localService.getSessionStorage();
        this._localService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setModelToForm() {
        if (this.formObject.tipo) {
            this.tipoLocalObject = this._localService.getTipoLocal(this.formObject.tipo);
        }
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._localService.returnToOtherForm(this.otherForm, this.responseLocal);
        } else {
            this.goToList();
        }
    }

    private goToList() {
        this._localNavigationService.goToList();
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(locaisStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.nome = newAutoComplete.nome;
            this.formObject.tipo = newAutoComplete.tipo;

            this.setActionTitle(this.formObject.id);
            this.setModelToForm();
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
        this.getLocalCombustiveis(id);
    }

    private setNewNormal() {
        this.tipoLocalObject = this.tiposLocaisList[0];
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }

    //local combustivel
    private submitLocalCombustivel(localId: number) {
        let x = 0, lenX = this.localCombustiveis.length,
            object: any = {};

        for (x, lenX; x < lenX; x++) {
            object = this.localCombustiveis[x];
            if (object.preco) {
                object.localId = localId;
                object.combustivelId = object.combustivel.id;
                delete object['combustivel'];
                if (object.preco) {
                    object.preco = this._utilService.getCurrency(object.preco);
                }

                if (this.localCombustiveis[x].id) {
                    this.onEditLocalCombustivel(object);
                } else {
                    this.onAddLocalCombustivel(object);
                }
            }
        }
    }

    private onAddLocalCombustivel(object: any) {
        this._localApiService.onPostLocalCombustivel(object, this.onDoneLocalCombustivel);
    }

    private onEditLocalCombustivel(object: any) {
        this._localApiService.onPutLocalCombustivel(object, this.onDoneLocalCombustivel);
    }

    private onDoneLocalCombustivel = (function (Response: any) {

    }.bind(this));

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/locais/local-form/local-form.component.ts
 **/